module.exports = __webpack_public_path__ + "static/media/signage-indoor-img62.11b1ac53.jpg";